import React from 'react';
import { renderToString } from 'react-dom/server';
import { Map, Marker, Popup, TileLayer, GeoJSON, AttributionControl } from 'react-leaflet';
import L from 'leaflet';
import ScrollContainer from 'react-indiana-drag-scroll';
import leafletPip from "@mapbox/leaflet-pip";
import smoothscroll from 'smoothscroll-polyfill';
import NumberFormat from 'react-number-format';
import { GestureHandling } from "leaflet-gesture-handling";
import { ChartWahlbeteiligung } from './ChartWahlbeteiligung';
import { ChartRat } from './ChartRat';
import { ChartOB } from './ChartOB';
import { Search } from './Search';
import { BezirkLine } from './BezirkLine';
import geojson2svg, { Renderer } from 'geojson-to-svg';
import ReactHtmlParser from 'react-html-parser'


export const pointerIcon1 = new L.divIcon({
	className: 'custom-div-icon',
	html: "<div class='map-marker'>1</div>",
	iconSize: [16, 27],
	iconAnchor: [8, 27]
})

export const pointerIcon2 = new L.divIcon({
	className: 'custom-div-icon',
	html: "<div class='map-marker'>2</div>",
	iconSize: [16, 27],
	iconAnchor: [8, 27]
})

export const pointerIcon3 = new L.divIcon({
	className: 'custom-div-icon',
	html: "<div class='map-marker'>3</div>",
	iconSize: [16, 27],
	iconAnchor: [8, 27]
})




export class Wahlkarte extends React.Component {
	constructor(props) {
		super(props);

		smoothscroll.polyfill();
		let city = document.getElementById('wahlkarte').getAttribute('data-city')
		
		let params = {}
		window.location.search.replace('?', '').split('&').forEach(paramStr => {
			params[paramStr.split('=')[0]] = paramStr.split('=')[1]
		})
		if ('city' in params) {
			city = params.city
			city = city.replace('oe', 'ö').replace('ue', 'ü')
		}

		let gestureHandling = false;
		if ('gestureHandling' in params && params.gestureHandling === 'true') {
			gestureHandling = true
		}

		let showBackLink = false
		if ('showBackLink' in params && params.showBackLink === 'true') {
			showBackLink = true
		}
		let svgVersion = false
		if ('svg' in params && params.svg === 'true') {
			svgVersion = true
		}

		let selected_wahltyp = 'OB';

		if ('wahltyp' in params && params.wahltyp === 'Rat') {
			selected_wahltyp = 'Rat'
		}

		let selected_karte = 'Gewinner'
		if ('kartentyp' in params) {
			selected_karte = params.kartentyp
		}

		if (["Duisburg", "NRW"].includes(city)) {
			selected_wahltyp = 'Rat'
		}

		let breakingPoint = 750
		//console.log('window.innerHeight', window.innerHeight, window.innerWidth)
		this.state = {
			windowHeight: window.innerHeight,
			mobileScreen: window.innerWidth < breakingPoint ? true : false,
			gestureHandling: gestureHandling,
			breakingPoint: breakingPoint,
			showBackLink: showBackLink,
			svgVersion: svgVersion,
			city: city,
			geojson: null,
			parteien: null,
			ob_kandidaten: null,
			csvRows: null,
			karten: null,
			bezirksdaten: null,
			stadtteillabels: null,
			waehlergruppen: null,
			selected_wahltyp: selected_wahltyp,
			selected_karte: selected_karte,
			karte_selection_pos: "left",
			selected_bezirk: 0,
			showAbsolute: false,
			zoom: 12,
			bezirkLine: {
				show: false
			},
			showPopup: true,
			karteSelectionIsScrolling: false
		}

		this.closePopoverTimeout = null

		this.karteSelectionContainerRef = React.createRef()  
		this.geojsonLayerRef = React.createRef()  
		this.overviewRef = React.createRef();
		this.leafletMapRef = React.createRef();
		this.popupRef = React.createRef();

		this.processData = this.processData.bind(this);
		this.scroll_karteselection = this.scroll_karteselection.bind(this);
		this.getBezirkStyle = this.getBezirkStyle.bind(this);
		this.handleZoomChange = this.handleZoomChange.bind(this);
		this.changeBeirk = this.changeBezirk.bind(this);
		this.removeBezirkLine = this.removeBezirkLine.bind(this);
		this.handleResize = this.handleResize.bind(this);
		this.handleAdressClick = this.handleAdressClick.bind(this);
		this.changeProzAbs = this.changeProzAbs.bind(this);
		this.scrollErgebnisseIntoView = this.scrollErgebnisseIntoView.bind(this);
		this.moveFeature = this.moveFeature.bind(this);
		this.SVGstyle = this.SVGstyle.bind(this);
	}

	componentDidMount() {
		fetch(process.env.PUBLIC_URL + '/' + this.state.city.replace('ö', 'oe').replace('ü', 'ue') + '_Parteien.json')
			.then(res => res.json())
			.then(parteien => {
				parteien.Sonstige = {
					"Partei": "Sonstige",
					"Farbe": "#A9A9A9",
					"sonstige": false
				}
				this.setState({
					parteien: parteien
				})
				this.processData()
			})

		if (["Duisburg"].includes(this.state.city)) {
			this.setState({
				ob_kandidaten: {}
			})
			this.processData(this.state.city == 'NRW')
		} else {
			fetch(process.env.PUBLIC_URL + '/' + this.state.city.replace('ö', 'oe').replace('ü', 'ue') + '_obkandidaten.json')
				.then(res => res.json())
				.then(ob_kandidaten => {
					ob_kandidaten.Sonstige = {
						"name": "Sonstige",
						"partei": null,
						"amtierend": false,
						"sonstige": false
					}
					this.setState({
						ob_kandidaten: ob_kandidaten
					})
					this.processData()
				})
		}

		fetch('https://interaktiv.rp-online.de/php/kommunalwahl2020/data/' + this.state.city.replace('ö', 'oe').replace('ü', 'ue') + '-stimm.csv', {
			headers: {
				'Cache-Control': 'no-cache, no-store, must-revalidate',
				'Pragma': 'no-cache',
				'Expires': 0
			}
		// fetch(process.env.PUBLIC_URL + '/' + this.state.city.replace('ö', 'oe').replace('ü', 'ue') + '-stimm.csv', {
		// 	headers: {
		// 		'Cache-Control': 'no-cache, no-store, must-revalidate',
		// 		'Pragma': 'no-cache',
		// 		'Expires': 0
		// 	}
  		})
			.then(res => res.text())
			.then(csvStr => {
				csvStr = csvStr.replace(/"(\d+),(\d+)"/g, '$1.$2').replace(/ID,/g, 'id,') //.replace(/,/g, ';').replace(/"/g, '')
				const csv=require('csvtojson')
				csv({checkType: true, delimiter: [','], quote: '"'})
					.fromString(csvStr)
					.then(csvRows => {
						this.setState({
							csvRows: csvRows
						})
						this.processData()
					})
			})


		fetch(process.env.PUBLIC_URL + '/' + this.state.city.replace('ö', 'oe').replace('ü', 'ue') + '.json')
			.then(res => res.json())
			.then(json => {
				this.setState({
					geojson: json
				})
			})


		fetch(process.env.PUBLIC_URL + '/' + this.state.city.replace('ö', 'oe').replace('ü', 'ue') + '_bezirke.json')
			.then(res => res.json())
			.then(json => {
				this.setState({
					stadtteillabels: json
				})
			})

		if (this.state.city === 'NRW') {
			fetch(process.env.PUBLIC_URL + '/NRW_waehlergruppen.json')
				.then(res => res.json())
				.then(json => {
					this.setState({
						waehlergruppen: json,
					})
					this.processData()
				})	
		}

	}

	processData() {

		function compare(a, b) {
			if (parseInt(a.proz) > parseInt(b.proz)) {
				return -1;
			}
			if (parseInt(a.proz) < parseInt(b.proz)) {
				return 1;
			}
			return 0;
		}

		if (this.state.parteien && this.state.ob_kandidaten && this.state.csvRows && (this.state.waehlergruppen || this.state.city !== 'NRW')) {
			let karten_infos = {
				"min": 101.0,
				"max": -1.0
			}
			let karten = {
				"Rat": {
					"Gewinner": Object.assign({}, karten_infos)
				},
				"OB": {
					"Gewinner": Object.assign({}, karten_infos)
				}
			}
			for (let partei_key in this.state.parteien) {
				karten.Rat[partei_key] = Object.assign({}, karten_infos)
			}

			for (let bewerber_key in this.state.ob_kandidaten) {
				karten.OB[bewerber_key] = Object.assign({}, karten_infos)
			}

			karten.Rat.Sonstige = Object.assign({}, karten_infos)
			karten.Rat.Wahlbeteiligung = Object.assign({}, karten_infos)
			karten.OB.Sonstige = Object.assign({}, karten_infos)
			karten.OB.Wahlbeteiligung = Object.assign({}, karten_infos);

			["Rat", "OB"].forEach(wahltyp => {
				for (let karten_key in karten[wahltyp]) {
					karten[wahltyp][karten_key].beste_bezirke = [{
						"proz": 0.0
					}]
				}
			})

			let bezirksdaten = {}

			let ausgezaehlt = 0;

			this.state.csvRows.forEach(row => {
				if (row.auszaehlung == 100 && row.id != 0) {
					ausgezaehlt += 1;
				}
				row.gewinner = {};
				row.gewinner_proz = {};

				["Rat", "OB"].forEach(wahltyp => {
					let bezirksgewinner = null;
					let bezirksgewinner_proz = 0.0;

					for (let karten_key in karten[wahltyp]) {

						var suffix;
						if (wahltyp === "Rat" || karten_key === 'Wahlbeteiligung') {
							suffix = "_2020_proz"
						} else {
							suffix = "_proz"
						}

						let value = row[karten_key + "_" + wahltyp + suffix]
						if (["Gewinner"].includes(karten_key)) {

						} else {
							// Parteiergebnisse Extrema
							if (row.id != 0 && value > karten[wahltyp][karten_key].max) {
								karten[wahltyp][karten_key].max = value
							}
							if (row.id != 0 && value < karten[wahltyp][karten_key].min) {
								karten[wahltyp][karten_key].min = value
							}

							
							if (karten_key !== "Wahlbeteiligung") {

								// Gewinner im Bezirk
								if (karten_key !== "Sonstige" && value > bezirksgewinner_proz) {
									bezirksgewinner = karten_key
									bezirksgewinner_proz = value
								}

							}


							// Beste Bezirke
							let beste_bezirke = karten[wahltyp][karten_key].beste_bezirke
							if (row.id != 0 && value >= beste_bezirke[beste_bezirke.length - 1].proz && row.auszaehlung == 100) {
								let length;
								if (this.state.city === 'NRW') {
									length = beste_bezirke.unshift({
										"wahlbuero": row.Gemeinden,
										"id": row.id,
										"proz": value
									})
								} else { 
									length = beste_bezirke.unshift({
										"wahlbuero": row.wahlbuero,
										"id": row.id,
										"proz": value
									})
								}
								if (length > 3) {
									beste_bezirke.pop()
								}
								beste_bezirke.sort(compare)
							}
						}
					}
					//console.log('bezirksgewinner_proz', row.id, wahltyp, bezirksgewinner_proz, karten[wahltyp].Gewinner.max)
					// Gewinner Extrema
					if (bezirksgewinner_proz > karten[wahltyp].Gewinner.max) {
						karten[wahltyp].Gewinner.max = bezirksgewinner_proz
					}
					if (bezirksgewinner_proz < karten[wahltyp].Gewinner.min) {
						karten[wahltyp].Gewinner.min = bezirksgewinner_proz
					}

					row.gewinner[wahltyp] = bezirksgewinner
					row.gewinner_proz[wahltyp] = bezirksgewinner_proz
				})
				bezirksdaten[row.id] = row;
				bezirksdaten[row.id].marked = false;
			})
			console.log('Wahlkarte Parteien', this.state.parteien)
			console.log('Wahlkarte Kandidaten', this.state.ob_kandidaten)
			console.log('Wahlkarte Karten', karten)
			console.log('Wahlkarte Bezirksdaten', bezirksdaten)
			this.setState({
				karten: karten,
				bezirksdaten: bezirksdaten,
				ausgezaehlt: ausgezaehlt
			})
		}


	}

	change_wahltyp(wahltyp) {
		if (wahltyp !== this.state.selected_wahltyp) {
			let karte = "Gewinner";
			if (["Gewinner", "Sonstige", "Wahlbeteiligung"].includes(this.state.selected_karte)) {
				karte = this.state.selected_karte
			} else if (wahltyp === "Rat") {
				if (this.state.ob_kandidaten[this.state.selected_karte].partei in this.state.parteien) {
					karte = this.state.ob_kandidaten[this.state.selected_karte].partei
				}
			} else {
				for (const [bewerber_key, bewerber] of Object.entries(this.state.ob_kandidaten)) {
					if (bewerber.partei === this.state.selected_karte) {
						karte = bewerber_key
					}
				}
			}
			this.setState({
				selected_wahltyp: wahltyp,
				selected_karte: karte
			})
		}
	}

	change_karte(karte) {
		let karte_selection_pos = null;
		let karten_index = 0;
		for (let karten_key in this.state.karten[this.state.selected_wahltyp]) {
			if (karte === karten_key) {
				break
			} else {
				karten_index += 1;
			}
		}

		if (karten_index === 0) {
			karte_selection_pos = "left"
		} else if (Object.keys(this.state.karten[this.state.selected_wahltyp]).length - 1 === karten_index) {
			karte_selection_pos = "right"
		}

		this.setState({
			selected_karte: karte,
			karte_selection_pos: karte_selection_pos
		})
	}

	scroll_karteselection(direction) {
		if (this.state.karte_selection_pos === direction) {
			return
		}
		let offset = 0;
		let childNodes = Object.entries(this.karteSelectionContainerRef.current.container.current.childNodes)
		let select_child_index = 0;
		for (let [index, element] of childNodes) {
			if (direction === "right") {
				offset += element.clientWidth + 2;
				if (element.classList.contains("active")) {
					select_child_index = parseInt(index) + 1
					break;
				}
			} else {
				if (childNodes[parseInt(index) + 1][1].classList.contains("active")) {
					select_child_index = parseInt(index)
					break;
				} else {
					offset += element.clientWidth + 2;
				}
			}
		}
		let karte_selection_pos = null;
		if (select_child_index === 0) {
			karte_selection_pos = "left"
		} else if (childNodes.length - 1 === select_child_index) {
			karte_selection_pos = "right"
		}
		let i = 0;
		let selected_karte;
		for (let key in this.state.karten[this.state.selected_wahltyp]) {
			if ((key in this.state.parteien && this.state.parteien[key].sonstige === false)
				|| (key in this.state.ob_kandidaten && this.state.ob_kandidaten[key].sonstige === false)
				|| (!(key in this.state.ob_kandidaten) && !(key in this.state.parteien))) {
					if (i === select_child_index) {
						selected_karte = key
						break
					}
					i++;
			}
		}
		this.setState({
			selected_karte: selected_karte,
			karte_selection_pos: karte_selection_pos
		})
		this.karteSelectionContainerRef.current.getElement().scrollTo({
			left: offset,
			behavior: 'smooth'
		})
	}

	// Hellt eine Farbe col um den Wert amt auf
	adjustDarkness(col, amt) {
	    var R = parseInt(col.slice(1).substring(0,2),16) - amt;
	    var G = parseInt(col.slice(1).substring(2,4),16) - amt;
	    var B = parseInt(col.slice(1).substring(4,6),16) - amt;

	    if (R > 255) R = 255;
	    else if (R < 0) R = 0;

	    if (G > 255) G = 255;
	    else if (G < 0) G = 0;

	    if (B > 255) B = 255;
	    else if (B < 0) B = 0;

	    var RR = ((R.toString(16).length===1)?"0"+R.toString(16):R.toString(16));
	    var GG = ((G.toString(16).length===1)?"0"+G.toString(16):G.toString(16));
	    var BB = ((B.toString(16).length===1)?"0"+B.toString(16):B.toString(16));

	    return "#" + RR + GG + BB;
	}

	getBezirkStyle(geoJsonFeature) {
		let BezirkStyle = {
			"color": "#f3f3f3",
			"weight": 1,
			"fillColor": "#ffffff",
			"fillOpacity": 0.8
		};

		if (!(this.state.bezirksdaten[geoJsonFeature.properties.ID])) {
			console.log('ERROR', geoJsonFeature.properties)
			return BezirkStyle
		}
		//console.log(this.state.bezirksdaten[geoJsonFeature.properties.ID])
		if (this.state.bezirksdaten[geoJsonFeature.properties.ID].auszaehlung == 100) {
			//console.log('id', geoJsonFeature.properties)
			let karte = this.state.karten[this.state.selected_wahltyp][this.state.selected_karte]
			let proz;
			let partei;

			if (this.state.selected_karte === 'Gewinner') {
				
				proz = this.state.bezirksdaten[geoJsonFeature.properties.ID].gewinner_proz[this.state.selected_wahltyp]
				
				if (this.state.selected_wahltyp === 'Rat') {
					partei = this.state.bezirksdaten[geoJsonFeature.properties.ID].gewinner[this.state.selected_wahltyp]
				} else {
					partei = this.state.ob_kandidaten[this.state.bezirksdaten[geoJsonFeature.properties.ID].gewinner[this.state.selected_wahltyp]].partei;
				}
				if (partei in this.state.parteien) {
					BezirkStyle.fillColor = this.state.parteien[partei].Farbe;
				} else {
					BezirkStyle.fillColor = this.state.parteien.Sonstige.Farbe
				}
				
			} else {
				let suffix;
				if (this.state.selected_wahltyp === 'Rat' || this.state.selected_karte === 'Wahlbeteiligung') {
					suffix = "_2020_proz"
				} else {
					suffix = "_proz"
				}
				proz = this.state.bezirksdaten[geoJsonFeature.properties.ID][this.state.selected_karte + "_" + this.state.selected_wahltyp + suffix];
				if (this.state.selected_karte === 'Wahlbeteiligung') {
					BezirkStyle.fillColor = '#2699fb'
				} else {
					if (this.state.selected_wahltyp === 'Rat') {
						partei = this.state.selected_karte
						BezirkStyle.fillColor = this.state.parteien[this.state.selected_karte].Farbe;
					} else {
						if (["Sonstige"].includes(this.state.selected_karte)) {
							partei = "Sonstige"
							BezirkStyle.fillColor = this.state.parteien.Sonstige.Farbe
						} else {
							partei = this.state.ob_kandidaten[this.state.selected_karte].partei;
							if (partei in this.state.parteien) {
								BezirkStyle.fillColor = this.state.parteien[partei].Farbe;
							} else {
								BezirkStyle.fillColor = '#A9A9A9'
							}
						}
					}
				}
			}

			if (karte.max - karte.min !== 0) {
				if (['FDP', 'Sonstige', 'Gruene', 'GRÜNE', 'Grüne', 'Freie', 'es'].includes(partei)) {
					if (proz > 1) {
						console.log(proz, this.state.bezirksdaten[geoJsonFeature.properties.ID])
					}
					BezirkStyle.fillColor = this.adjustDarkness(
						BezirkStyle.fillColor, 
						Math.floor(
							75 * (((proz - karte.min) / (karte.max - karte.min)) * 2 - 0.6)
						)
					)
				} else {
					BezirkStyle.fillColor = this.adjustDarkness(
						BezirkStyle.fillColor, 
						Math.floor(
							75 * (((proz - karte.min) / (karte.max - karte.min)) * 2 - 1)
						)
					)
				}
			}
			
			if (this.state.bezirksdaten[geoJsonFeature.properties.ID].marked) {
				BezirkStyle.weight = 7
			}
		}
		return BezirkStyle
	}

	onEachFeature(feature, layer) {
		layer.on({
			click: this.clickToFeature.bind(this),
			mouseover: this.mouseoverFeature.bind(this),
			mouseout: this.mouseoutFeature.bind(this),
			mousemove: this.moveFeature.bind(this),
		});
	}

	clickToFeature(e) {
		this.markBezirk(e.containerPoint.x, e.containerPoint.y, e.target.feature.properties.ID)
	}

	handleAdressClick(coordinates) {
		let feature = leafletPip.pointInLayer(coordinates, this.geojsonLayerRef.current.leafletElement, true)
		if (feature[0]) {
			let id = feature[0].feature.properties.ID
			let pixel_pos = this.leafletMapRef.current.leafletElement.latLngToContainerPoint([coordinates[1], coordinates[0]])
			this.markBezirk(pixel_pos.x, pixel_pos.y, id)
		}
	}

	markBezirk(x1, x2, selected_bezirk) {
		let bezirkLine = {
			show: true,
			x1: x1,
			y1: x2
		}
		let bezirksdaten = this.state.bezirksdaten
		if (this.state.selected_bezirk) {
			bezirksdaten[this.state.selected_bezirk].marked = false
		}
		bezirksdaten[selected_bezirk].marked = true;
		this.setState({
			selected_bezirk: selected_bezirk,
			bezirkLine: bezirkLine,
			bezirksdaten: bezirksdaten
		})
	}

	handleResize(e) {
		if (window.innerWidth < this.state.breakingPoint && this.state.mobileScreen === false) {
			this.setState({
				mobileScreen: true
			})
		} else if (window.innerWidth >= this.state.breakingPoint && this.state.mobileScreen === true) {
			this.setState({
				mobileScreen: false
			})
		}
		this.removeBezirkLine()
	}

	removeBezirkLine() {
		if (this.state.bezirkLine.show) {
			this.setState({
				bezirkLine: {
					show: false
				}
			})
		}
	}

	mouseoverFeature(e) {
		let row = this.state.bezirksdaten[e.target.feature.properties.ID]

		if (this.closePopoverTimeout) {
			clearTimeout(this.closePopoverTimeout);
		}
		this.popupRef.current.leafletElement.setContent(renderToString(
			<div>
				<div className="popoverInner">
					<p><b>{this.state.selected_wahltyp ==  "Rat" 
							? (["Rhein-Sieg-Kreis"].includes(this.state.city) ? "Kreistagswahl" : "Ratswahl")
							: (this.state.city === 'Neuss' ? "Bürgermeisterwahl" : (["Rhein-Sieg-Kreis"].includes(this.state.city) ? "Landratswahl" : "OB-Wahl"))}</b> 
								{this.state.city.startsWith('NRW')
									? <><b> </b>{row.Gemeinden}</>
									: (["Rhein-Sieg-Kreis", "Neuss"].includes(this.state.city)
										? <> {row.wahlbuero}</>
										: <><b> im Stimmbezirk </b>{row.id}</>
									)
								}
					</p>
					{!(this.state.city.startsWith('NRW')) && !(["Rhein-Sieg-Kreis", "Neuss"].includes(this.state.city)) &&
						<p className="twoLinesHeigth"><b>{this.state.city === 'Neuss' ? 'Wahlbezirk' : 'Wahlbüro' }</b> {row.wahlbuero}</p>
					}
					<hr />
					{this.state.selected_wahltyp == "Rat"
						?
							<ChartRat 
								parteien={this.state.parteien} 
								waehlergruppen={this.state.waehlergruppen}
								bezirksdaten={row}
								showAbsolute={this.state.showAbsolute}
								preview={true}
							/>
						:
							<ChartOB 
								parteien={this.state.parteien} 
								bezirksdaten={row}
								ob_kandidaten={this.state.ob_kandidaten}
								showAbsolute={this.state.showAbsolute}
								preview={true}
							/>
					}


				</div>
				<div className="grey-box">
					<p>Mehr Informationen beim Klick</p>
					<img
						src="data:image/svg+xml;base64,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"
						height="15px" 
						width="15px"
						alt="Cursor-Icon"
					/>
				</div>
			</div>
		))

		e.target.setStyle({
			"weight": 7,
		}) 
	}

	moveFeature(e) {

		let popupHeight = this.popupRef.current.leafletElement._container.clientHeight
		let popupWidth = this.popupRef.current.leafletElement._container.clientWidth
		let mouseX = e.containerPoint.x
		let mouseY = e.containerPoint.y
		let popupOffset = this.popupRef.current.leafletElement.options.offset

		let overview_pos = this.overviewRef.current.getBoundingClientRect()
		let overviewX;
		if ("x" in overview_pos) {
			overviewX = overview_pos.x;
		} else {
			overviewX = overview_pos.right - overview_pos.width; // Edge
		}

		let newPopupOffsetX = 0
		let newPopupOffsetY = 0

		if (mouseY < popupHeight + 20) {
			newPopupOffsetY = popupHeight + 65
		}

		if (popupWidth / 2 + mouseX > overviewX - 15) {
			newPopupOffsetX = (-1) * (popupWidth / 2 - (overviewX - mouseX) + 15)
		} else if (mouseX < popupWidth / 2) {
			newPopupOffsetX = popupWidth / 2 - mouseX
		}

		if (popupOffset != [newPopupOffsetX, newPopupOffsetY]) {
			this.popupRef.current.leafletElement.options.offset = [newPopupOffsetX, newPopupOffsetY]
		}
		




		this.popupRef.current.leafletElement.setLatLng(e.latlng)
	}

	mouseoutFeature(e) {
		const self = this

		self.closePopoverTimeout = setTimeout(function () {
			self.popupRef.current.leafletElement.setLatLng([0, 0])
		}, 200)
		

		if (e.target.feature.properties.ID != self.state.selected_bezirk) {
			e.target.setStyle({
				"weight": 1
			}) 
		}
	}

	handleZoomChange(e) {
		if ((e.target._zoom >= 14 && this.state.zoom < 14)
			|| (e.target._zoom < 14 && this.state.zoom >= 14)) {
			this.setState({zoom: e.target._zoom})
		}
	}

	changeBezirk(bezirk_id) {
		let bezirksdaten = this.state.bezirksdaten
		//console.log('bezirksdaten', bezirksdaten)
		if (this.state.selected_bezirk) {
			bezirksdaten[this.state.selected_bezirk].marked = false
		}
		this.removeBezirkLine()
		this.setState({
			selected_bezirk: bezirk_id,
			bezirksdaten: bezirksdaten
		})
	}


	changeProzAbs(e) {
		this.setState({
			showAbsolute: e.target.checked
		})
	}

	scrollErgebnisseIntoView() {
		this.overviewRef.current.scrollIntoView({
			behavior: 'smooth',
			block: 'start'
		})
	}
	SVGstyle(geoJsonFeature) {
		let org_style = this.getBezirkStyle(geoJsonFeature)
		return { fill: org_style.fillColor, stroke: org_style.color, 'stroke-width': '10px', opacity: '0.8'}
	}

	render() {

		if (!this.state.geojson || !this.state.bezirksdaten || !this.state.stadtteillabels) {
			return (
				<div className="App" style={{height: this.state.windowHeight}}>
					<div className="lds-ellipsis large-loader"><div></div><div></div><div></div><div></div></div>
				</div>
			)
		} else {

			if (Object.keys(this.state.bezirksdaten).length === 0) {
				return ("Wahldaten liegen nicht vor.")
			}

			var bbox = require('geojson-bbox');
			let mapbox = bbox(this.state.geojson)
			

			const Erdradius = 6378137

			function squared (x) { return x * x }
			function toRad (x) { return x * Math.PI / 180.0 }
			function hav (x) {return squared(Math.sin(x / 2))}

			function haversineDistance (a, b) {
				const aLat = toRad(a[1])
				const bLat = toRad(b[1])
				const aLng = toRad(a[0])
				const bLng = toRad(b[0])

				const ht = hav(bLat - aLat) + Math.cos(aLat) * Math.cos(bLat) * hav(bLng - aLng)
				return 2 * Erdradius * Math.asin(Math.sqrt(ht))
			}
			let northSouthDist = haversineDistance([mapbox[0], mapbox[1]], [mapbox[0], mapbox[3]])

			
			let zoom = 10;
			let mapHeigth = this.state.windowHeight;
			if (window.innerWidth < this.state.breakingPoint) {
				mapHeigth *= 0.6;
			}
			for (let zoomLevel of [7,8,9,10,11,12,13,14]) {
				let metresPerPixel = 40075016.686 * Math.abs(Math.cos((mapbox[1] + mapbox[3]) / 2 * Math.PI/180)) / Math.pow(2, zoomLevel+8);

				if (mapHeigth * metresPerPixel > northSouthDist) {
					zoom = zoomLevel
				} else {
					break
				}
			}

			let center = [(mapbox[1] + mapbox[3]) / 2, (mapbox[0] + mapbox[2]) / 2]
			let metresPerPixel = 40075016.686 * Math.abs(Math.cos((mapbox[1] + mapbox[3]) / 2 * Math.PI/180)) / Math.pow(2, zoom+8);
			if (window.innerWidth < this.state.breakingPoint) {
				let coord_offset = (metresPerPixel * 54) / 111111
				center = [(mapbox[1] + mapbox[3]) / 2 + coord_offset, (mapbox[0] + mapbox[2]) / 2]
			}
			let bounds_offset = (metresPerPixel * 150) / 111111
			let maxBounds = [[mapbox[1] - bounds_offset, mapbox[0] - bounds_offset], [mapbox[3] + bounds_offset, mapbox[2] + bounds_offset]]

			// Berechne für alle 3 besten Bezirke den Mittelpunktkoordingaten des entsprechenden Geo-Features
			let beste_bezirke = this.state.karten[this.state.selected_wahltyp][this.state.selected_karte].beste_bezirke
			let marker_coordinates = [];
			beste_bezirke.forEach(bezirk => {
				if (bezirk.proz > 0.0) {
					for (let feature of Object.values(this.state.geojson.features)) {
						if (feature.properties.ID == bezirk.id && bezirk.proz) {
							let box = bbox(feature)
							marker_coordinates.push({
								'lat': (box[0] + box[2]) / 2,
								'lon': (box[1] + box[3]) / 2
							})
							break;
						}
					}
				}
			})
			const stadtteilMarker = [];
			this.state.stadtteillabels.forEach(label => {
				let marker = new L.divIcon({
					className: 'custom-div-icon',
					html: "<p class='stadtteil-marker'>" + label.Name + "</p>",
					iconSize: [100, 16],
					iconAnchor: [50, 8]
				})
				stadtteilMarker.push(marker)
			})

			if (this.state.svgVersion) {

				var reproject = require('reproject-spherical-mercator');
				var reprojected_geojson = reproject(this.state.geojson,'EPSG:4326','EPSG:3857');
				let svg = geojson2svg()
					.projection(function(coord) {
						return [coord[0], coord[1] * (-1)];
					})
					.styles(this.SVGstyle)
					.data(reprojected_geojson)
					.render();
				const element = document.createElement("a");
				const file = new Blob([svg], {type: 'text/plain'});
				element.href = URL.createObjectURL(file);
				element.download = this.state.city + '_' + this.state.selected_wahltyp + '_' + this.state.selected_karte + ".svg";
				document.body.appendChild(element); // Required for this to work in FireFox
				element.click();
				return (<div dangerouslySetInnerHTML={{__html: svg}}></div>)
			}
			return (
			<div className="App" style={{height: this.state.mobileScreen ? "unset" : this.state.windowHeight.toString() + 'px'}}>
				{this.state.showBackLink &&
					<div className="goback-link marginleft">
						<a href="javascript:history.back()" className="link">← Zurück zur vorherigen Ansicht</a>
					</div>
				}
				<div className="head marginleft margintop">
					{['Bonn', 'Rhein-Sieg-Kreis'].includes(this.state.city)
						? <img className="iconGA" alt="Logo der Website" src={process.env.PUBLIC_URL + '/GA-Logo.png'} />
						: (this.state.city === 'Aachen')
							? <img className="icon" style={{width: "103px"}} alt="Logo der Website" src={process.env.PUBLIC_URL + '/Logo_AZ_AN.png'} />
							: <img className="icon" alt="Logo der Website" src="https://interaktiv.rp-online.de/europawahl-2019/ergebnisse/nrw/img/rp-logo.svg" />
					}
					<div className="border-left">
						<h1>Kommunalwahl in {this.state.city.startsWith('NRW') ? 'NRW' : this.state.city } 2020</h1>
						<h2>Vorläufige Ergebnisse in den {this.state.city === 'NRW' ? 'kreisfreien Städten und Kreisen' : 'Stimmbezirken'}</h2>
					</div>
				</div>
				<Map
					style={{
						height: 
							this.state.mobileScreen
								? (this.state.selected_bezirk == 0 ? (this.state.windowHeight * 0.6).toString() + "px" : (this.state.windowHeight * 0.5).toString() + "px")
								: (this.state.windowHeight - 107).toString() + 'px'
					}}
					className={this.state.selected_bezirk == 0 ? "" : "small-map "}
					ref={this.leafletMapRef} 
					center={center} 
					zoom={zoom}
					minZoom={zoom-2}
					onZoomEnd={this.handleZoomChange} 
					onResize={this.handleResize} 
					onMovestart={this.removeBezirkLine}
					maxBounds={maxBounds}
					preferCanvas={true}
					addInitHooks={"addHandler", "gestureHandling", GestureHandling}
					gestureHandling={this.state.gestureHandling}
					gestureHandlingOptions={{
						duration: 1000,
						text: {
							touch: "Verwenden Sie zwei Finger, um die Karte zu bewegen",
							scroll: "Verwenden Sie Strg + Scrollen zum Zoomen der Karte",
							scrollMac: "Verwenden Sie \u2318 + Scrollen zum Zoomen der Karte"
						}
					}}
					attributionControl={false}
				>
					<AttributionControl position="bottomright" prefix="<a href='https://leafletjs.com/' target='_blank'>Leaflet</a>" />
					<Popup position={[0,0]} ref={this.popupRef} className="mobile-0" autoPan={false} closeOnClick={false} >
					</Popup>
					<BezirkLine 
						overviewRef={this.overviewRef} 
						leafletMapRef={this.leafletMapRef} 
						data={this.state.bezirkLine} 
						breakingPoint={this.state.breakingPoint}
					/>

					{this.state.stadtteillabels.map((label, index) => (
						<Marker 
								position={[label.Lat, label.Lon]}
								icon={stadtteilMarker[index]}
							>
						</Marker>
					))}
					{this.state.selected_karte != "Gewinner" && marker_coordinates[0] &&
						<>
							{marker_coordinates.length >= 1 &&
								<Marker 
									position={[marker_coordinates[0].lon, marker_coordinates[0].lat]}
									icon={pointerIcon1}
								>
								</Marker>
							}
							{marker_coordinates.length >= 2 &&
								<Marker 
									position={[marker_coordinates[1].lon, marker_coordinates[1].lat]}
									icon={pointerIcon2}
								>
								</Marker>
							}
							{marker_coordinates.length === 3 &&
								<Marker 
									position={[marker_coordinates[2].lon, marker_coordinates[2].lat]}
									icon={pointerIcon3}
								>
								</Marker>
							}
						</>
					}
					{this.state.zoom >= 14 &&
						<TileLayer
							//url='https:\/\/server.arcgisonline.com\/ArcGIS\/rest\/services\/World_Topo_Map\/MapServer\/tile\/{z}\/{y}\/{x}'
							//attribution='Karten-Daten: Esri'
							url='https:\/\/a.tile.openstreetmap.de\/{z}\/{x}\/{y}.png'
							attribution={'<a href="https://www.openstreetmap.org/copyright" target="_blank">© OpenStreetMap-Mitwirkende</a>'}

						/>
					}
					<GeoJSON 
						ref={this.geojsonLayerRef} 
						key='features' 
						data={this.state.geojson} 
						style={this.getBezirkStyle}
						onEachFeature={this.onEachFeature.bind(this)}
						attribution={this.state.mobileScreen 
										? 'Quelle: ' + (this.state.city == 'NRW' ? 'Landeswahlleiter NRW' : 'Wahlamt ' + this.state.city)
										: '<span class="mobile-0">Von <a href="https://twitter.com/boissereec" target="_blank">Clemens Boisserée</a>, <a href="https://twitter.com/philninh" target="_blank">Phil Ninh</a> und <a href="https://twitter.com/Matth_Meyer" target="_blank">Matthias Meyer</a></span> | Quelle: ' + (this.state.city == 'NRW' ? 'Landeswahlleiter NRW' : 'Wahlamt ' + this.state.city)
									}
					/>
				</Map>
				<div className="info-column">
					<div className="info-column-head margintop marginright">
						<Search city={this.state.city} 
								handleAdressClick={this.handleAdressClick} 
								removeBezirkLine={this.removeBezirkLine} 
								changeBezirk={this.changeBezirk}
						/>
						{!(["Duisburg", "NRW"].includes(this.state.city)) &&
							<>
								<div className="w100">
									<p className="karte-waehlen">Wählen Sie eine Karte</p>
								</div>
								<div>
									<button 
										className={"rounded-left border" + (this.state.selected_wahltyp === 'OB' ? " active bold" : "")} 
										onClick={() => this.change_wahltyp('OB')}>
											{this.state.city === 'Neuss' ? 'Bürgerm.-Wahl' : (["Rhein-Sieg-Kreis"].includes(this.state.city) ? "Landratswahl"  : 'OB-Wahl')}
									</button>
									<button
										className={"rounded-right border" + (this.state.selected_wahltyp === 'Rat' ? " active bold" : "")} 
										onClick={() => this.change_wahltyp('Rat')}>
											{["Rhein-Sieg-Kreis"].includes(this.state.city) ? "Kreistagswahl" : "Ratswahl"}
									</button>
								</div>
							</>
						}
					</div>
				</div>
				<div className="overview border rounded marginright" ref={this.overviewRef}>
					{this.state.selected_bezirk == 0
						? 
							<div className="order-0">
								<div className="flex-row">
									<h3 className="w100 h3gesamtergebnis">Gesamtergebnis</h3>
									<div className="mobile h3gesamtergebnis mouse-pointer" onClick={this.scrollErgebnisseIntoView}>
										<p>↓</p>
										<p>Zu den<br />Wahlergebnissen</p>
									</div>
								</div>
								<div className="info-box">
									<div>
										<p>{this.state.city === 'NRW' ? 'Kreise' : (this.state.city == 'Neuss' ? 'Wahlbezirke' : 'Stimmbezirke')}</p>
										<p>{this.state.geojson.features.length}</p>
										<p>Ausgezählt</p>
										<p>{this.state.ausgezaehlt}</p>
									</div>
									<div>
										<p style={{textAlign: "center"}}>Wahl<wbr />beteiligung</p>
										<ChartWahlbeteiligung 
											percentage={this.state.bezirksdaten[0].auszaehlung == "100" ? this.state.bezirksdaten[0]["Wahlbeteiligung_" + this.state.selected_wahltyp + "_2020_proz"] : 0}
										/>
									</div>
								</div>
							</div>
						: 
							<div className="order-0">
								<button className="link" onClick={() => this.changeBezirk(0)}><b>← Zurück zum Gesamtergebnis</b></button>
								<div className="flex-row">
									<h3 className="w100">
										Ergebnisse {this.state.city.startsWith('NRW')
														? ' ' +  this.state.bezirksdaten[this.state.selected_bezirk].Gemeinden
														: (["Rhein-Sieg-Kreis"].includes(this.state.city)
															? 'in der ' + this.state.bezirksdaten[this.state.selected_bezirk].wahlbuero
															: 'im '+ (this.state.city == 'Neuss' ? 'Wahlbezirk ' : 'Stimmbezirk ') + this.state.bezirksdaten[this.state.selected_bezirk].wahlbuero
														)
													}
									</h3>
								</div>
								<div className="info-box">
									{!(this.state.city.startsWith('NRW')) && !(["Rhein-Sieg-Kreis", 'Neuss'].includes(this.state.city)) &&
										<div>
											<p><b>{this.state.city === 'Neuss' ? 'Wahlbezirk' : 'Wahlbüro' }</b></p>
											<p>{this.state.bezirksdaten[this.state.selected_bezirk].wahlbuero}</p>
											{!(["Neuss", "Rhein-Sieg-Kreis"].includes(this.state.city)) &&
												<>
													<p><b>Adresse</b></p>
													<p>{this.state.bezirksdaten[this.state.selected_bezirk].adresse}</p>
												</>
											}
										</div>
									}
									<div className="w100">
										<p style={{textAlign: "center"}}><b>Wahl<wbr />beteiligung</b></p>
										<ChartWahlbeteiligung 
											percentage={this.state.bezirksdaten[this.state.selected_bezirk].auszaehlung == "100" ? this.state.bezirksdaten[this.state.selected_bezirk]["Wahlbeteiligung_" + this.state.selected_wahltyp + "_2020_proz"] : 0} 
										/>
									</div>
								</div>
							</div>
					}
					<hr className="order-0" />
					<div className="order-0 abs-proz-switch">
						<p>Ergebnisse</p>
						<div>
							<p>prozentual</p>
							<label className="switch">
								<input type="checkbox" checked={this.state.showAbsolute} onChange={this.changeProzAbs} />
								<span className="slider round"></span>
							</label>
							<p>absolut</p>
						</div>
					</div>
					{this.state.city !== 'Duisburg' && (this.state.city !== 'NRW' || this.state.selected_bezirk != 0) &&
						<>
							<div className={this.state.selected_wahltyp === "OB" ? "order-1" : "order-3"}>
								<h3>{this.state.city === "Neuss" ? "Bürgermeisterwahl" : ((this.state.city === 'NRW' && this.state.bezirksdaten[this.state.selected_bezirk].Wahl == 'LR' || ["Rhein-Sieg-Kreis"].includes(this.state.city)) ? "Landratswahl" : "Oberbürgermeisterwahl")}</h3>
								<ChartOB 
									parteien={this.state.parteien} 
									bezirksdaten={this.state.bezirksdaten[this.state.selected_bezirk]} 
									ob_kandidaten={this.state.city === 'NRW' ? this.state.ob_kandidaten[this.state.bezirksdaten[this.state.selected_bezirk].gebietsnummer] : this.state.ob_kandidaten}
									showAbsolute={this.state.showAbsolute}
								/>
							</div>
							<hr className="order-2" />
						</>
					}
					<div className={this.state.selected_wahltyp === "Rat" ? "order-1" : "order-3"}>
						<h3>{["Rhein-Sieg-Kreis"].includes(this.state.city) ? "Kreistagswahl" : "Ratswahl"}</h3>
						<ChartRat 
							parteien={this.state.parteien} 
							waehlergruppen={this.state.waehlergruppen}
							bezirksdaten={this.state.bezirksdaten[this.state.selected_bezirk]}
							showAbsolute={this.state.showAbsolute}
						/>
					</div>
				</div>

				<div className={"karte-selection " + (this.state.selected_bezirk == 0 ? "" : "mobile-0")}>
					<div className="scroll-container-wrapper">
						<div className={"scroll-container-el border arrow" + (this.state.karte_selection_pos === "left" ? " active" : "")} onClick={() => this.scroll_karteselection("left")}>
							<p>❮</p>
						</div>
						<ScrollContainer 
							className={"scroll-container " + (this.state.karteSelectionIsScrolling ? "" : "snapping-container")}
							ref={this.karteSelectionContainerRef} 
							hideScrollbars={false}
							onStartScroll={() => {this.setState({'karteSelectionIsScrolling': true})}}
							onEndScroll={() => {this.setState({'karteSelectionIsScrolling': false})}}
						>
							{Object.keys(this.state.karten[this.state.selected_wahltyp]).map(karten_key => (
								(
										(	karten_key in this.state.parteien 
											&& this.state.parteien[karten_key].sonstige === false 

										)
									|| 
										(
											karten_key in this.state.ob_kandidaten 
											&& this.state.ob_kandidaten[karten_key].sonstige === false
										)
									|| 
										(
											!(karten_key in this.state.ob_kandidaten) 
											&& !(karten_key in this.state.parteien)
										)
								)
									&& 
										<div 
											className={"scroll-container-el border snapping-child " + (this.state.selected_karte === karten_key && "active")}
											onClick={() => this.change_karte(karten_key)}
										>
											{karten_key === "Gewinner"
											?
												<>
													<p><b>Gewinner</b></p>
													<p style={{"whiteSpace": "normal", "minWidth": "200px"}}><small>Wer hat in welchen Bezirken am besten abgeschnitten?</small></p>
												</>
											:
												<>
													<div className="scroll-container-el-head w100">
														<p>
															<b>
																{this.state.selected_wahltyp === "Rat" || karten_key === "Sonstige" || karten_key === "Wahlbeteiligung" ? (karten_key in this.state.parteien ? this.state.parteien[karten_key].Partei : karten_key)
																	: this.state.ob_kandidaten[karten_key].name_kurz
																		+ (this.state.ob_kandidaten[karten_key].partei 
																			? "  (" 
																				+ (this.state.ob_kandidaten[karten_key].partei in this.state.parteien
																					?  this.state.parteien[this.state.ob_kandidaten[karten_key].partei].Partei
																					: this.state.ob_kandidaten[karten_key].partei
																				)
																				+ ")" 
																			: " (parteilos)")
																}
															</b>
														</p>
														<p>
															{this.state.selected_wahltyp === "Rat" || karten_key === "Wahlbeteiligung"
																? <NumberFormat value={this.state.bezirksdaten[0][karten_key + "_" + this.state.selected_wahltyp + "_2020_proz"]} decimalScale={1} fixedDecimalScale={true} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} suffix={" %"} />
																: <NumberFormat value={this.state.bezirksdaten[0][karten_key + "_" + this.state.selected_wahltyp + "_proz"]} decimalScale={1} fixedDecimalScale={true} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} suffix={" %"} />
															}
														</p>
													</div>
													{this.state.karten[this.state.selected_wahltyp][karten_key].beste_bezirke.map((bezirk, index) => (
														<div className="list">
															<div className="list-row">
																{bezirk.proz
																	?
																		<>
																			<div style={{"color": "black"}}>
																				{index+1}
																			</div>
																			<div>
																				{bezirk.wahlbuero}
																			</div>
																			<div>
																				<b><NumberFormat value={bezirk.proz} decimalScale={1} fixedDecimalScale={true} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} />&nbsp;%</b>
																			</div>
																		</>
																	: ""
																}
															</div>
														</div>
													))}

												</>
											}
										</div>
							))}
						</ScrollContainer>
						<div className={"scroll-container-el border arrow" + (this.state.karte_selection_pos === "right" ? " active" : "")} onClick={() => this.scroll_karteselection("right")}>
							<p>❯</p>
						</div>
					</div>
				</div>
			</div>
			)
		}

	}
}